import * as React from "react";
import { Props } from "../types";
import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';
import View from 'ol/View.js';
import { fromLonLat } from "ol/proj";
import { Overlay } from "ol";

export const OpenLayerMap = (props: Props.OpenLayerMap) => {

    const mapContainerRef = React.useRef<HTMLDivElement>(null);
    const overlayContainerRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {

        if(mapContainerRef.current && overlayContainerRef.current) {

            const pos = fromLonLat([parseFloat(props.lon), parseFloat(props.lat)]);

            const overlay = new Overlay({
                element: overlayContainerRef.current as HTMLElement,
                autoPan: {
                    animation: {
                        duration: 250,
                    }
                },
            });

            const map = new Map({
                target: mapContainerRef.current as HTMLElement,
                layers: [
                    new TileLayer({
                        source: new OSM(),
                    }),
                ],
                overlays: [overlay],
                view: new View({
                    center: pos,
                    zoom: 16,
                }),
            });


            overlay.setPosition(pos);
        }

    },[mapContainerRef,overlayContainerRef])

    return <div className={'c-ol-map'}>
        <div className={`h-sr-only `}><h3>Kaart met locatie behorend bij artikel</h3></div>
        <div ref={mapContainerRef} className="c-ol-map__container"></div>
        <div ref={overlayContainerRef} className="c-marker">
            <div className="c-marker__pin"></div>
        </div>
    </div>
}
